module.exports = __webpack_public_path__ + "img/icons8-compose-100 1.4c0a0b8b.svg";